<template>
    <Dialog v-model:open="open">
        <DialogContent class="sm:max-w-[425px]">
            <DialogHeader>
                <DialogTitle>Add SMS Global server</DialogTitle>
            </DialogHeader>
            <div class="space-y-3">
                <FormField name="title" v-slot="{ componentField }">
                    <FormItem>
                        <FormLabel>Title (Required)</FormLabel>
                        <FormControl>
                            <Input v-bind="componentField" placeholder="Title" />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                </FormField>
                <FormField name="description" v-slot="{ componentField }">
                    <FormItem>
                        <FormLabel>Description (Optional)</FormLabel>
                        <FormControl>
                            <Input v-bind="componentField" placeholder="description" />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                </FormField>
            </div>
            <DialogFooter>
                <Button type="button" variant="secondary" :disabled="isCreatePending" @click="close"
                    >Cancel</Button
                >
                <Button
                    type="button"
                    :loading="isCreatePending"
                    :disabled="!meta.valid || !meta.dirty"
                    @click="submit"
                    >Save</Button
                >
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import { Button } from '@/components/ui/button'
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { smsGlobalServerFormSchema } from '@/lib/schema/v1/sms-global'
import { setFieldsError } from '@/lib/utils'
import { useAddSMSGlobalServerMutation } from '@/queries/sms-global'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm } from 'vee-validate'
import { computed } from 'vue'

const open = defineModel()

const { mutate: addServer, isPending: isCreatePending } = useAddSMSGlobalServerMutation()

const form = useForm({
    validationSchema: toTypedSchema(smsGlobalServerFormSchema),
})

const meta = computed(() => form.meta.value)

const submit = form.handleSubmit(async (values) => {
    if (!meta.value.dirty || !meta.value.valid) return

    const payload = {
        ...values,
        api_key: 'c04780e67d9361df64e1ee15ba88dc78',
        api_secret: '799d172d121fdac184f56d121b73e5a1',
        api_url: 'https://api.smsglobal.com',
        origin: 'Cynergic',
    }

    addServer(payload, {
        onSuccess: () => {
            close()
        },
        onError: (error) => {
            console.log(error)
            setFieldsError(error, form.setFieldError)
        },
    })
})

const close = () => {
    open.value = false
    form.resetForm()
}
</script>
